import { useCallback } from 'react';

import { type WorkspaceMemberRoleDisplayName } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type CopiedMemberInviteLink = { roleId: string; role?: WorkspaceMemberRoleDisplayName };

export const useTrackCopiedInviteMemberLink = () => {
  const { track } = useAnalyticsUtilities();

  const trackCopiedInviteMemberLink = useCallback(
    (params: CopiedMemberInviteLink) => {
      track(`Copied a member invite link`, params, { integrations: { 'Customer.io (Actions)': true, Intercom: true } });
    },
    [track],
  );

  return { trackCopiedInviteMemberLink };
};
